import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Login from "./Login.js"

export default function SideLogin(){

  return (
    <Stack
      direction={{ xs: 'column-reverse', md: 'row' }}
      sx={{
        justifyContent: 'center',
        gap: { xs: 6, sm: 12 },
        p: 2,
        mx: 'auto',
      }}
    >
      <Stack sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450}}>
        <Typography variant="h3">Nesting Web Service</Typography>
        <Typography variant="h5">A powerful and tested solution</Typography>
        <Typography>You are using the same algorithm that we are using and have developed over the years. We provide multiple features tailored to the need of 3D printing service bureaus.</Typography>
        <Typography variant="h5">Saas integration</Typography>
        <Typography>Want to integrate a nesting a algorithm on your production management software? Use our api to upload models, nest them and retrieve positions.</Typography>
        <Typography variant="h5">Competitive prices</Typography>
        <Typography>Choose the licence according to your nesting requirements.</Typography>
      </Stack>
      <Login/>
    </Stack>
  )
}
